import React from 'react';
import { Container, Row} from 'react-bootstrap';
import FaqCard from './FaqCard';

import FaqIcon1 from '../../assets/img/title-icon.png';

const questions = [
    {
        no: "01",
        title: "如果我想報名103K挑戰組，該去哪裡報名？",
        ans: "本活動一律採伊貝特線上報名（https://bao-ming.com/eb/content/6882#32494 ），報名時間為2026/2/6（五）12:00至2026/8/15（六），現已截止。103K挑戰組依大會成績排名，男女組前三名敘獎；電輔車組無敘獎。",
    },
    {
        no: "02",
        title: "103K挑戰組需要什麼樣的資格才可以報名？",
        ans: "限7歲以上（未滿16歲須附監護人同意書），且身心健康、具有良好純熟單車騎乘技術及經驗，體能可在6小時內完騎，並願意遵守道路交通規則與大會交通維運工作人員引導、安全騎乘者，即符合資格。",
    },
    {
        no: "03",
        title: "只有103K總計時第一名才可以去法國比賽嗎？",
        ans: "103K挑戰組僅總冠軍可獲得2027 L’Étape法國世界錦標賽參賽資格（機票、住宿自理），並獲頒黃衫及獎盃；第二、三名獲頒獎盃。另登山王（KOM）男女冠軍可獲得圓點衫、法國世界錦標賽參賽資格及獎盃。",
    },
    {
        no: "04",
        title: "登山王需要額外報名嗎？",
        ans: "不用。賽程中設置兩段登山王爬坡區段：第一段為投147線3K（南港二號橋）至投147線10K涼亭後（賽道約44K至51K），第二段為台21線76K至70.5K（賽道約70K至75.5K）。兩路段分別以晶片計時，以兩段加總時間作為排名依據，103K挑戰組選手皆會算入登山王成績；須於10:50前抵達終點方具登山王資格。電輔車組不列入。",
    },
    {
        no: "05",
        title: "請問這個獎項是環法官方認證的名次嗎？",
        ans: "是的，作為環法官方系列賽，本站各項名次皆為環法官方認證成績。",
    },
]

const questionsEng = [
    {
        no: "01",
        title: "How do I register for 103K The Race?",
        ans: "Registration is online only, via Ebet (https://bao-ming.com/eb/content/6882#32494). Registration ran from February 6, 2026 (Fri), 12:00 to August 15, 2026 (Sat) and is now closed. 103K The Race is ranked by official time, with awards for the top 3 men and women; there are no awards for the e-bike categories.",
    },
    {
        no: "02",
        title: "What are the requirements to register for 103K The Race?",
        ans: "Riders must be aged 7 or over (under 16 requires a parental/guardian consent form), be in good physical and mental health, have solid cycling skills and experience, be fit enough to finish within 6 hours, and agree to obey traffic rules, follow the directions of event traffic control staff, and ride safely.",
    },
    {
        no: "03",
        title: "Is only the overall winner of the 103K timed race eligible to race in France?",
        ans: "In 103K The Race, only the overall champion wins a spot at the 2027 L’Étape France world championship (flights and accommodation at the rider's own expense), along with the Yellow Jersey and a trophy; second and third place receive trophies. In addition, the men's and women's King of the Mountains (KOM) winners receive the Polka Dot Jersey, qualification for the world championship in France, and a trophy.",
    },
    {
        no: "04",
        title: "Do I need to register separately for the KOM competition?",
        ans: "No. The course includes two King of the Mountains (KOM) climbs: the first from Route 147 3K (Nangang No. 2 Bridge) to just past the pavilion at Route 147 10K (course km 44-51), and the second from Provincial Highway 21 76K to 70.5K (course km 70-75.5). Each climb is chip-timed separately, and the combined time of both climbs determines the ranking, so all 103K The Race riders are automatically included. You must reach the finish before 10:50 to be eligible for KOM. E-bike riders are not included.",
    },
    {
        no: "05",
        title: "Are these rankings officially certified by the Tour de France?",
        ans: "Yes. As an official Tour de France series event, all rankings at L'Étape Sun Moon Lake are officially certified by the Tour de France.",
    },
]

const CompetitionQ = ({language}) => {
    return (
        <section className="faq-competition">
            <Container>
                <Row className='align-items-center faq-section'>
                    <h2 className='faq-header'><span><img className='faq-icon' src={FaqIcon1} alt="" /></span>{language === "Chinese" ? "競賽相關問題" : "Competition"}</h2>
                    {language === "Chinese" ? 
                        questions.map((q, index) => (
                            <FaqCard
                                key={index}
                                {...q}
                            />
                        ))
                    : 
                        questionsEng.map((q, index) => (
                            <FaqCard
                                key={index}
                                {...q}
                            />
                        ))
                    }
                </Row>
            </Container>
        </section>
    )
}

export default CompetitionQ